import { TFunction } from "react-i18next";

import { OrderTransportationTypeMode } from "./enums";

const getOrderTransportationTypeOptions = (translate: TFunction<"translation", undefined>) => {
  const options = [
    { value: OrderTransportationTypeMode.ASSISTANCE, label: translate("assistance") },
    { value: OrderTransportationTypeMode.DOOR_TO_DOOR, label: translate("doorToDoor") },
    { value: OrderTransportationTypeMode.DOOR_TO_PORT, label: translate("doorToPort") },
    { value: OrderTransportationTypeMode.DOOR_TO_WAREHOUSE, label: translate("doorToWarehouse") },
    { value: OrderTransportationTypeMode.FOT_RESIDENCE, label: translate("fotWarehouse") },
    { value: OrderTransportationTypeMode.PORT_TO_DOOR, label: translate("portToDoor") },
    { value: OrderTransportationTypeMode.PORT_TO_PORT, label: translate("portToPort") },
    { value: OrderTransportationTypeMode.PORT_TO_WAREHOUSE, label: translate("portToWarehouse") },
    { value: OrderTransportationTypeMode.WAREHOUSE_TO_DOOR, label: translate("warehouseToDoor") },
    {
      value: OrderTransportationTypeMode.WAREHOUSE_TO_WAREHOUSE,
      label: translate("warehouseToWarehouse"),
    },
    { value: OrderTransportationTypeMode.WAREHOUSE_TO_PORT, label: translate("warehouseToPort") },
  ];

  return options;
};

export { getOrderTransportationTypeOptions };
